export default __webpack_public_path__ + "static/histogram-with-specified-bins-0f03a57152f99922a8a19013cfbbfee3.png";